import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface RegisterDeviceParams {
  token: string
  /** IANA time zone of the phone, so reminders ring at local hours. */
  timeZone?: string
  /** Language the app is shown in, for the texts of the notifications. */
  language?: string
}

const registerDevice = async ({ token, timeZone, language }: RegisterDeviceParams): Promise<void> => {
  await api.post('/devices', { token, timeZone, language })
}

/**
 * Register an FCM device token with the API. Registering the same phone
 * again is fine: the API keeps one row per phone and moves it to the account
 * signed in on it.
 */
export const useRegisterDevice = () => {
  return useMutation<void, Error, RegisterDeviceParams>({
    mutationFn: registerDevice,
    onError: (err: Error & { response?: { data?: { code?: string } } }) => {
      const code = err.response?.data?.code
      if (code === 'Notifications.DeviceAlreadyRegistered') {
        // Older API: the token is already in the table.
        return
      }
      throw err
    },
  })
}
